<header class="hero">
  <h1>
    <img
      class="logo"
      src="logo/SUPAY-logo.svg"
      alt=""
      width="320"
      height="336"
    />
    <span class="visually-hidden">{{ contact.company }}</span>
  </h1>
</header>
<address class="contact">
  <h2>Contact</h2>
  <p>{{ contact.address }}<br />{{ contact.town }}</p>
  <p>
    <a [href]="'tel:' + phoneDigits">{{ contact.phone }}</a>
    ·
    <a [href]="'https://wa.me/' + phoneDigits.slice(1)">WhatsApp</a>
  </p>
  <p>
    <a [href]="'mailto:' + contact.email">{{ contact.email }}</a>
  </p>
  <p>
    <a [href]="'https://www.instagram.com/' + contact.instagram.slice(1)">{{
      contact.instagram
    }}</a>
  </p>
</address>
<router-outlet></router-outlet>
